import React from "react";
import { CustomSlider, OpacityActionsContainer, SliderContainer } from "../sidebar/OpacitySliderStyle";
import { setOpacity, useOpacity } from "../../features/mapDisplay/mapDisplaySlice";
import { OPACITY } from "../UserVisibleStrings";
import { useDispatch } from "react-redux";
import { setAlertOpacity, useAlertOpacity, useShouldShowAlerts } from "../../features/alertDisplay/alertDisplaySlice";

const OpacitySlider: React.FC = ( ) =>
{
    const dispatch = useDispatch();
    const alertOpacity = useAlertOpacity();
    const surfaceOpacity = useOpacity();
    const isShowingAlerts = useShouldShowAlerts();
    const opacity = isShowingAlerts ? alertOpacity : surfaceOpacity;

    const handleOpacityChange = ( event: Event, newValue: number | Array<number> ) =>
    {
        if ( isShowingAlerts )
        {
            dispatch( setAlertOpacity( newValue as number ) );
        }
        else
        {
            dispatch( setOpacity( newValue as number ) );
        }
    };

    return (
        <OpacityActionsContainer>
            <SliderContainer>
                <span style = {{ margin: "0 10px", position: "relative", fontSize: "1.1em" }}>
                    {OPACITY}
                </span>
                <CustomSlider
                    value = {opacity}
                    min = {0}
                    max = {1}
                    step = {0.01}
                    onChange = {handleOpacityChange}
                />
            </SliderContainer>
        </OpacityActionsContainer>
    );
};

export default OpacitySlider;
